import { render, staticRenderFns } from "./AlterarDataLaudo.vue?vue&type=template&id=d64238d4&"
import script from "./AlterarDataLaudo.vue?vue&type=script&lang=js&"
export * from "./AlterarDataLaudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports